import React from "react";

function Artwork() {
  return (
    <div>
      <div className="artwork-wrapper fixe-top">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>ANSON THYMES Y</h1>
                <p>VOICED BY JESS HARNELL</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>Karl with a ‘k’</h1>
                  <h2>
                    abilites powers Can tell if the letter y is a vowel in any
                    sentane
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">the villians guild of america</h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      the guy can only tell if the letter ‘y’ is a look it says
                      it overy there thats really it what more do you want?
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/1.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>CHAMELEON MAN</h1>
                <p>VOICED BY KHARY PYTON</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>WAYNE JHONSTEIN</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    KNOWS HE’S IN A CARTOON -rich af -pronounces it,
                    ‘’tour-nuh-men’’ not-’’ternament’’
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      avenging justice guild club league squad force -team
                      chamelon man -trouble local 153
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      following a screening of ‘’the shadow’’ his fithy rich
                      pare parents were murdered during the ensuing celebration
                      of cinema breakin the 4th wall chameleon man goes nuts and
                      uses his inheritence to fight crime and make bad 4th wall
                      breaking jokes
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/2.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>eaglepeeper</h1>
                <p>VOICED BY carlos alazraqui</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-flint mardon</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -can do archery -special themed arrow -master of disguise
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      the avenging justic guild club league squad force -the men
                      of arrows
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -secretly trapesing around at night as the villanous knave
                      fared by no one, the night danger ti tge oublic, he is
                      known only as the famous hero called eaglepeeper
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/3.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the everloving bush</h1>
                <p>VOICED BY ice-t</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-n/a</h1>
                  <h2>abilites powers</h2>
                  <h2>-deadlist being alive -perfect aim -super sneaky</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      the avenging justic guild club league squad force -the men
                      of arrows
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -grown in the upper depths of the great white
                      north(canada), the everloving bush is the canucks most
                      fared & beloved bounty hunter
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/4.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>president george washington</h1>
                <p>VOICED BY maurice lamarche</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-geo washton</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -cannot tell a lie -created america -loves advertising
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      the avenging justic guild club league squad force -the men
                      of arrows
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -while attempting to cross the delaware, george washington
                      was swept up in an avenging justice guild club league
                      squad force adventure and now he’s stuck with ‘em poor
                      bastard
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/5.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the grasshopper</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-henrietta plamer</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -cannot tell a lie -created america -loves advertising
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      the avenging justic guild club league squad force -the men
                      of arrows
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -while attempting to cross the delaware, george washington
                      was swept up in an avenging justice guild club league
                      squad force adventure and now he’s stuck with ‘em poor
                      bastard
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/6.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the jerusalman</h1>
                <p>VOICED BY maurice lamarche</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-arthur peeper</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -super strength -flight -can we talk to all the animals of
                    the sky
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      the avenging justic guild club league squad force -the men
                      of arrows
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -raised by a mormon family in inland arthurpeeper soon
                      discovered he wasn’nt like everyone else on his way to a
                      missionary trip to egypt, arthur is swept into the ocean
                      only to be saved and discovered his truth path he is the
                      jerusalman the lost heir to the throne of the mystical
                      floating holy city of jerusalem
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/7.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the lizard king</h1>
                <p>VOICED BY richard horvitz</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-jedediah stone</h1>
                  <h2>abilites powers</h2>
                  <h2>-lizard mech suit -lizard powers -more lizard powers</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -the villians guild of america -the union of reptillian
                      villians -customer @johnstein insurance
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -turned into a tiny lizard during one of chameleon man’s
                      missions gone wrong, jedediah stone vows revenge against
                      the blent kinight !
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/8.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>mister zordo</h1>
                <p>VOICED BY tata sciore</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-n/a</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -master of the transmorphing plane -comprised of pure
                    transmorphing energy
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -the spider-rangers -the council of zordos
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      eons ago zordo discovered a source of unquantfiable power,
                      the transmorphing plane. each generation, he and his
                      trusty robot omega 9, seek out young adults with anger
                      issues to become the legendary spider rangers and the
                      spider-rangers . together. they fight to protect the plane
                      rom the growing evil
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/9.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>nurse justice</h1>
                <p>VOICED BY tata sciore</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-n/a</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -master of the transmorphing plane -comprised of pure
                    transmorphing energy
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -the spider-rangers -the council of zordos
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      eons ago zordo discovered a source of unquantfiable power,
                      the transmorphing plane. each generation, he and his
                      trusty robot omega 9, seek out young adults with anger
                      issues to become the legendary spider rangers and the
                      spider-rangers . together. they fight to protect the plane
                      rom the growing evil
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/10.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>omega 9</h1>
                <p>VOICED BY richard horvitz</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-n/a</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -master of the transmorphing plane -comprised of pure
                    transmorphing energy
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">-the spider-rangers</h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -built by the protector of the transmorphing plane,mister
                      zordo, omega-9 helps in the interdimensional crusade of
                      good alongside spider rangers and the spider-rangers
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/11.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>VOICED BY phil s devone</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-unknown</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -has a time/space ship -pretty ok leader -knows everything
                    (literally)
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -founder of the b.l.a.n.k.e.t -the legendary time lost
                      painters -what’s 4
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -coming from a race of immortal being only known as,
                      ‘’fury’s’’ unkown to them as to why,they will randomly,
                      and unwillingly, change their appearance.he’s one of the
                      deadliest men in the universe. losing both eyes to
                      unkown,yet separate incidents, processor what’s sheer
                      badassness allows him to navigate wearing to eye patches
                      with ease also two eye patches is more extreme. -the
                      avenging justics guild club league squad force
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/12.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>sean astin</h1>
                <p>VOICED BY sean astin</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-sean astin</h1>
                  <h2>abilites powers</h2>
                  <h2>-is sean astin -reality bending -magic stuff</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -avenging justic guild club league squad force -the court
                      of astins -the astinleague
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -afyer neomh nprm sean astin, sean astin soon discovered
                      he could sean astin with the best of ‘em. also, he
                      hadsuper seansome seanbilities. after conquiring every
                      aspect of hollywood, sean decided to use his new powers to
                      save everyone.
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/13.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the arrow of david</h1>
                <p>VOICED BY jeff mcmahon</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-sean astin</h1>
                  <h2>abilites powers</h2>
                  <h2>-is sean astin -reality bending -magic stuff</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -avenging justic guild club league squad force -the men of
                      arrows -the congregation of jewperheroes
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -after 5 years in hell (michigan), tolliver greenstein waS
                      HIRED BY his hometown to protext his city (park)
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/14.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the artist donatello</h1>
                <p>VOICED BY barry gordon</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-donatdo di niccol di betto bardi</h1>
                  <h2>abilites powers</h2>
                  <h2>-renaissance man -legendary italian -loves pizza</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -avenging justic guild club league squad force -the men of
                      arrows -the congregation of jewperheroes
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -after 5 years in hell (michigan), tolliver greenstein waS
                      HIRED BY his hometown to protext his city (park)
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/15.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the artist leonardo</h1>
                <p>VOICED BY cam clarke</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-donatdo di niccol di betto bardi</h1>
                  <h2>abilites powers</h2>
                  <h2>-renaissance man -legendary italian -loves pizza</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">-the legendary time lost painters</h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -after being pulled from his timestream on earth iota, the
                      artist and the other legendary time lost painters were
                      rescued by profespr what unable ,or unwilling, to return
                      them to their timeline the professor brings them along on
                      his adventures through the whole of reality and time
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/16.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the artist michelangelo</h1>
                <p>VOICED BY townsend coleman</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-n/a</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -renaissance man -legendary italian -loves pizza (cause he’s
                    italian yup) (thats’s why)
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -the legendary time lost painters -the b.l.a.n.k.e.t
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -after being pulled from his timestream on earth iota, the
                      artist and the other legendary time lost painters were
                      rescued by profespr what unable ,or unwilling, to return
                      them to their timeline the professor brings them along on
                      his adventures through the whole of reality and time
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/17.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the artist raphael</h1>
                <p>VOICED BY robs paulsen</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-raffaello santi</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -renaissance man -legendary italian -loves pizza (cause he’s
                    italian yup) (thats’s why)
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">-the legendary time lost painters</h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -after being pulled from his timestream on earth iota, the
                      artist and the other legendary time lost painters were
                      rescued by profespr what unable ,or unwilling, to return
                      them to their timeline the professor brings them along on
                      his adventures through the whole of reality and time
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/18.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the chartreuse bowman</h1>
                <p>VOICED BY steve blum</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-tolliver greenstein</h1>
                  <h2>abilites powers</h2>
                  <h2>-decent with arrows -great with puns -horrible lover</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -avenging justic guild club league squad force -the men of
                      arrows -bantam city mayors office
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -he’s chartreuse and he’s a bowman definitely dont google
                      chartreuse and synonyms for bowman no need
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/19.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the insanely awesome</h1>
                <p>VOICED BY steve blum</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-nurse ruse tanner</h1>
                  <h2>abilites powers</h2>
                  <h2>-insanely awesome -you’ll love him when he’s awesome</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -avenging justic guild club league squad force -the men of
                      arrows -bantam city mayors office
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -he’s chartreuse and he’s a bowman definitely dont google
                      chartreuse and synonyms for bowman no need
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/20.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>the jupiterman</h1>
                <p>VOICED BY nolan north</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-mark trent/kajor le</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -faster than quickly fired ammunation -more powerful than an
                    old school train -can hop over big buildings in one giant
                    leap
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -avenging justic guild club league squad force -the men of
                      arrows -bantam city mayors office
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -in the future, during the destruction of pluto, scientst
                      kajor le is vaporized by a malfunctioning matter ray. not
                      exactly sure how, he’s able to reconstitute himself as a
                      child on earth with incredible abilities found and raised
                      by a hippie commune in trent, england, he holds the ideals
                      of peace,love,and the flower child way.to the public he
                      goes by mark trent : professional blogger, but when danger
                      is abound he leaps into action (in a non-voilent way) as
                      the jupiterman!
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/21.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>THE NIGHT DANGLER</h1>
                <p>VOICED BY CARLOS ALAZRAQUL</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-nurse ruse tanner</h1>
                  <h2>abilites powers</h2>
                  <h2>-dangles in the night</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -THE VILLAINS GUILD OF AMERICA -THOSE WHO IN THE NIGHT
                      ANONYMOUS
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -TO THE PUBLIC, FLINT MARDON IS INOWN AS THE FAMOUS HERO
                      CALLED EADLEPEEPER...SECRETLY THOUGH, HE DOUBLES AS THE
                      VILLANOUS KNAVE FEARED BY NO ONE, THE NIGHT DANGER
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/22.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>THE RABBIT</h1>
                <p>VIOCED BY MASON HEIDGER</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-ETHANIEL EAST</h1>
                  <h2>abilites powers</h2>
                  <h2>-BUNNY COSTUME WITH SUPER SPEED</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -THR AVENGING JUSTICE GULD CLUB LEAGUE SQUAD FORCE -FUTURE
                      RABBITS OF AMERICA -DR.FATHER'S BOOK CLUB
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      AFTER BEING THROWN INTO A DUMPSTER BY HIS SYATE
                      CHAMPIONSHIP WINNING MIME CLUB FORM HIS HIGHSCHOOL,
                      ETHANEL EAST FIND RATTY PINK BUNNY COSTUME.TRYING IT ON,
                      HE DISCOVERS IT HAS THE ABILATY OF SUPER SPEED
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/23.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>THE RED MOUNTIE (OF ONTARIO)</h1>
                <p>VOICED BY ROSS MARQUAND</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-HAROLD HORTON</h1>
                  <h2>abilites powers</h2>
                  <h2>-COSMIC MAPLE POWERED HOCKED GLOCE -FANTASTIC CURLER</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -THE RED MOUNTIE BRIGADE -THE SONS OF CANADA -COACHES HIS
                      NIECES HOCKEY TEAM
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -RUMORED TO BE THE DISTANT RELATIVE OF CANADIAN AND COFFEE
                      GREAT TIM HORTON, HAROLD'S BUDDING HOCKEY CAREER WAS PUT
                      TO AN END WHEN HE WAS INJURED IN S RUNAWAY ZAMBONI
                      ACCIDENT. RECRUITED FOR HIS HIGH APPTITUDE OF ALL THAT'S
                      CANDIAN, HE BECOMES THE RED MOUNTIE OF ONTARIO
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/24.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>THE SPIDER RANgER</h1>
                <p>VOICED BY CROIX PROVENCE</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-PETRA PLANTER</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    ABILITIES OF A SPIDER -ACCESS TO THE TRANSMORPHING PLANE
                    -HAS A GIANT ASS MECH
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -THE SPIDER-RANGES -THE SPIDER RANGES AND THE SPIDER
                      RANGES
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -BITTEN BY A RADIOACTIVE SPIDER-RODOT PETRA PLANTER'S
                      UNIQUE RADIOACTIVE SIGNATURE ALLOWED HER TO BE LOCATED BY
                      BEING FORM ANOTHER DIMENSION CALLED MISTER ORDO AND HIS
                      ANDROID AIR TO T RANSEORM INTO A FORCE FOR JUSTICE.
                      TOGETHER THE THREE BAND TOGETHER TO STOP EVIL!
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/25.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>VANISH:THE INVISIBLE MAN</h1>
                <p>VOICED BY ROB PAULSEN</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-KELLY KELLY JR</h1>
                  <h2>abilites powers</h2>
                  <h2>-IS INVISIBLE -IS ANGRY ABOUT IT -GREAT PICKPOKET</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -ANENGING JUSTICE GUILD CLUB LEAGUE AQUAD FORCE -VANISH
                      AND THE INVISIBLE MAN -HAS BLUE CORSS?
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -BOUGHT HIS POWERS FORM A STORES AND EVENTUALLY HAD BUYERS
                      REMORES... BUT THE RECIPT WAS IN THE PANTS HE WORE THAT
                      DAY AND CAN'T FIND IT.
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/26.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="artwork-wrapper">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-xl-8 col-lg-12">
              <div className="artwork-title">
                <h1>YENTEL</h1>
                <p>VOICED BY ROB PAULSEN</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 ">
              <div className="left-card">
                <div className="card-content-inner">
                  <h2>Secret identity</h2>
                  <h1>-ELI BLACKSTEIN</h1>
                  <h2>abilites powers</h2>
                  <h2>
                    -FORMER PRO DREICELER -CAN LEAP LARGE LATKAS IN A SINGLE
                    BOUND
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-xl-6 col-lg-8">
                  <div className="center-card">
                    <h2>affliations</h2>
                    <h2 className="mt-3">
                      -THE AVENGING JUSTICE GUILD CLUB LEAGUS SQUAD FORCE
                      -CHAMELEON MAN &HIS JEWTASTIC FRIEND! -THE CONGREGTION OF
                      JEWPERHEROES
                    </h2>
                  </div>

                  <div className="center-card mt-3">
                    <h2>bio</h2>
                    <h2>
                      -WHILE COMPETING IN INTERNATIONAL DREIDEL CHAMPIONSHIP,
                      ELIPERMENANELY IN JURED HIS DREIDEL FINGER. STUCK AT HOME
                      WITH NOTHING TO DO,HIS GRANDMA, THE LEGENDARY BABUSHKA,
                      ENLSTS HIM INTO HER ONE GRANDMA FIGHT FOR JEWSTICE!
                    </h2>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="artwork-img">
                    <img src="assets/img/artwork/27.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Artwork;
